<template>
  <div class="articlePage">
    <div v-if="this.$store.state.webNavigator=='pc'">
      <div class="max1720 news-list flexStart">
        <div>
          <!-- 二级导航 -->
          <twoLevelList v-show="pageType"
                        :classCode="classType"
                        :titles="titles"
                        :tltType="twolist?'1':'2'"
                        :act="active?active:''"
                        :twolist="navLsit"
                        :toLeveListPath="toLeveListPath"
          />
        </div>
        <!-- 文章 -->
        <div class="news-list-left">
          <div class="news-list-bar pointEr"
               v-for="(item , index) in newslist" :key="index"
               @click="gotoPath(item)"
          >
            <div class="news-bar-left displayIB">
              <img class="news-list-img" :src="httptype(item.articleImg)" :alt="item.pictag?item.pictag:''" title="">
            </div>
            <div class="news-bar-right displayIB positionRE">
              <div class="font26px news-list-Tlt">{{item.articleTitle}}</div>
              <div class="font16px col666666 news-list-Text">{{ellipsis(item.simpleContent)}}</div>
              <span v-if="item.simpleContent" class="font16px col00CDA2">查看全文>></span>
              <div class="font16px col99999 news-list-icon positionAB">
                <!--                <span>来源:{{titles}}</span>-->
                <span class="Time-down text-down displayIB">
                </span>
                <span>{{item.submissionTime}}</span>
                <span class="see-down text-down displayIB">
                </span>
                <span>{{item.viewingCount}}</span>
              </div>
            </div>

          </div>
        </div>
        <div class="news-list-right">
          <articleSidebar/>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.webNavigator=='phone'">
      <div>
        <div class="articlePhone-list">
          <div>
            <twoLevelList v-show="titles!='品牌资讯'"
                          :classCode="classType"
                          :titles="titles"
                          :tltType="twolist?'1':'2'"
                          :act="active?active:''"
                          :twolist="navLsit"
                          :toLeveListPath="toLeveListPath"
            />
          </div>
          <div class="articlePhone-listBar"
               v-for="(item , index) in newslist"
               :key="index"
               @click="gotoPath(item)">
            <div class="displayIB articlePhone-ImgBox">
              <img class="articlePhone-listImg"
                   :src="httptype(item.articleImg)"
                   :alt="item.pictag?item.pictag:''" title="">
            </div>
            <div class="displayIB articlePhone-TextBox">
              <div class="articlePhone-listP font24phone">{{PhoneEllipsis(item.articleTitle,'1')}}</div>
              <div class="font20phone col99999">
                <div class=" articlePhone-listP2">{{PhoneEllipsis(item.simpleContent,'2')}}
                  <span v-if="item.simpleContent" class="col00CDA2">查看全文>></span>
                </div>
              </div>
              <div class="time-look">
                  <div>
                    <span class="Time-down  displayIB"></span>
                    <span class="text-down"> {{item.submissionTime}} </span>
                  </div>
                  <div>
                    <span class="see-down  displayIB"></span>
                    <span class="text-down"> {{item.viewingCount}}</span>
                  </div>
                </div>
            </div>
          </div>
          <div v-show="pageLength<count" @click="getMore()" class="marginAuto phone-more col33333 font22phone">
            加载更多
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

// import tltNav from '../../weightLossInfo/tltNav/tltNav';
import twoLevelList from '../../../components/twoLevelList/twoLevelList';// 二级栏
import articleSidebar from '../../../components/articleSidebar/articleSidebar';// 文章侧边栏
import config from '@/others/interface';
import {$get, $post, } from '@/others/ajax';
import { myFun } from '../../../plug/modifyImagePath'

export default {
  name: 'articlePage',
  components: {
    twoLevelList, articleSidebar,
  },
  // tltNav,
  props: {
    pageType: {
      type: Boolean,
      default: true,
    },
    listType: {
      type: String,
      default: null,
    },
    titles: {
      type: String,
      default: null,
    },
    active: {
      type: String,
      default: null,
    },
    classType: {
      type: String,
      default: null,
    },
    pageIndex: {
      type: Number,
      default: null,
    },
    navLsit: {
      type: Array,
      default: null,
    },
    toLeveListPath: {
      type: String,
      default: '/',
    },
  },
  data () {
    return {
      reg: /<\/?.+?\/?>/g,
      newslist: [],
      hotList: [],
      recommodList: [],
      imgUrl: 'https://jusexcx.zmelo.com/',
      // 二级分类
      twolist: [],
      //
      count: '',
      pageSize: '12',
      pageLength: 0,
    };
  },
  watch: {
    $route (to, form) {
    },
  },
  methods: {
    getList () {
      $get(config.zmlgw + '/web/getList', {
        code: this.listType,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data.rows.length > 0) {
            this.newslist = [...this.newslist, ...res.data.rows, ];
          }
          this.count = res.data.count;
          this.pageLength = this.newslist.length;
          this.$emit('getTotal', res.data.count);
          this.getRightList();
        }
      });
    },
    async getRightList () {
      let res = await $get(config.zmlgw + '/web/getOne', {pageSize: 10, firstPage: 6, });
      if (res.code == 200) {
        this.recommodList = res.data.recommod;
        this.hotList = res.data.data;
      }
    },
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return myFun(url);
        }
      }
    },
    ellipsis (text) { // 超出30字省略
      if (text) {
        text.toString();
        if (text.length > -1) {
          let len = text.length;
          if (len > 30) {
            let str = '';
            str = text.substring(0, 60) + '...';
            return str;// 将替换的值赋值给当前对象
          }
        } else {
          return text;
        }
      }
    },
    PhoneEllipsis (text, textType) { // 超出10字省略
      let textSize;
      if (textType == '2') {
        textSize = 15;
      } else if (textType == '1') {
        textSize = 25;
      }
      if (text) {
        text.toString();
        if (text.length > -1) {
          let len = text.length;
          if (len > 10) {
            let str = '';
            str = text.substring(0, textSize) + '...';
            return str;// 将替换的值赋值给当前对象
          }
        } else {
          return text;
        }
      }
    },
    gotoPath (item) {
      if (sessionStorage.getItem('brandInfo')) {
        sessionStorage.removeItem('brandInfo');
      }
      let backRouter = window.location.href.split('.com')[1];
      let brandInfo = {
        toLeveListPath: this.toLeveListPath,
        articleKeyWord: item.articleKeyWord,
        toLeveRouter: backRouter,
        bannerName: item.secondaryColumnName,
        secondColumnId: item.secondaryColumnId,
      };
      sessionStorage.setItem('brandInfo', JSON.stringify(brandInfo));
      this.$router.push({path: `/brandNewsInfo/${item.articleid}/1/${item.articleid}.html`, });
    },
    getMore () {
      this.pageIndex += 1;
      this.getList();
    },
  },
  asyncData ({store, route, app, }) {

  },
  mounted () {
    this.getList();
  },
  beforeDestroy () {
  },
  computed: {},
  created () {
  },
  filters: {},
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('../../listPage/articlePage/articlePagePhone');
  }

  @media screen and (min-width: 800px) {
    @import url('../../listPage/articlePage/articlePage');
  }
</style>



// WEBPACK FOOTER //
// articlePage.vue